import { render, staticRenderFns } from "./EducationalPeriodAdd.vue?vue&type=template&id=789a48cc&"
import script from "./EducationalPeriodAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports